module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#arrow",
      toString: function () {
        return this.url;
      }
    }